import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useImportMutationBankUIContext } from "../ImportMutationBankUIContext";
import { ImportMutationBankCreateForm } from "./ImportMutationBankCreateForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/import-mutation-bank/importMutationBankAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import * as XLSX from "xlsx";
import moment from "moment";
import ImportMutationBankTable from "./ImportMutationBankTable";
import LoadingAnimation from "../loading-animation/LoadingAnimation";

export const ImportMutationBankCreateDialog = ({ id, history }) => {
  // ImportMutationBank Redux state
  const dispatch = useDispatch();
  const {
    actionsLoading,
    importMutationImportMutationBankForEdit,
    error,
  } = useSelector(
    (state) => ({
      actionsLoading: state.importMutationImportMutationBanks.actionsLoading,
      importMutationImportMutationBankForEdit:
        state.importMutationImportMutationBanks
          .importMutationImportMutationBankForEdit,
      error: state.importMutationImportMutationBanks.error,
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting ImportMutationBank by id
    dispatch(actions.fetchImportMutationBank(id));
  }, [id, dispatch]);

  const [arrayFile, setArrayFile] = useState([]);

  const previewFile = (e) => {
    const [file] = e.target.files;
    const reader = new FileReader();

    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const result = XLSX.utils.sheet_to_json(ws, { header: 1 });
      let arrayData = [...arrayFile];
      result.forEach((data, index) => {
        if (index !== 0) {
          let obj = {};
          data.forEach((item, index) => {
            if (index !== 0) {
              if (index === 1) {
                const trxDate = moment(
                  Math.floor(item - 25569) * 86400 * 1000
                ).format("YYYY-MM-DD"); // to convert date from excel like 44239
                obj.trx_date = trxDate;
              }
              index === 2 && (obj.message = item);
              index === 3 && (obj.amount = item);
            }
          });
          arrayData.push(obj);
        }
      });
      setArrayFile(arrayData);
    };
    reader.readAsBinaryString(file);
  };

  const [bankAccountUuid, setBankAccountUuid] = useState("");
  const bankAccount = (value) => {
    setBankAccountUuid(value.uuid);
  };

  const submitData = () => {
    dispatch(
      actions.createImportMutationBank({
        bank_account_uuid: bankAccountUuid,
        import_data: arrayFile,
      })
    ).then(() => history.push("/donasi/bank-import"));
  };

  const downloadTemplate = () => {
    window.open(
      "https://docs.google.com/spreadsheets/d/1Qa1YOkW_pvgINHiQkPEGA1sEux9Pkr0Y4p1YqUhTGfg/edit?usp=sharing"
    );
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader title="Bank">
          <CardHeaderToolbar>
            <button className="btn btn-primary" onClick={downloadTemplate}>
              Download Template
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <ImportMutationBankCreateForm
            actionsLoading={actionsLoading}
            importMutationImportMutationBank={{}}
            previewFile={previewFile}
            bankAccount={bankAccount}
          />
        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Mutasi Rekening" />
        <CardBody>
          <ImportMutationBankTable dataTable={arrayFile} />
        </CardBody>
        <CardFooter>
          {arrayFile.length > 0 && (
            <>
              <button
                className="btn btn-primary float-right"
                onClick={submitData}
              >
                Simpan
              </button>
            </>
          )}
        </CardFooter>
      </Card>
    </>
  );
};
